import React, { useEffect } from 'react';
import { useOidcAccessToken, useOidc } from "@axa-fr/react-oidc";
import { useNavigate } from 'react-router-dom';
import { useFetchWrapper } from '../../hooks/useFetchWrapper';
import { clientConfig } from '../../utilities/configService';

interface AccessTokenPayload {
    sub: string;
    given_name: string;
    family_name: string;
    email: string;
    client_id: string;
    audience: string | string[];
    force_password_change: string;
}

const processToken = async (accessTokenPayload: AccessTokenPayload, fetchWrapper: any) => {
    const processRequest = {
        userIdentifier: accessTokenPayload.sub,
        firstName: accessTokenPayload.given_name,
        lastName: accessTokenPayload.family_name,
        accountEmail: accessTokenPayload.email,
        profileEmail: accessTokenPayload.email,
        applicationName: clientConfig?.APPLICATION_NAME || ''
    };
    sessionStorage.removeItem('needRelogin');
    fetchWrapper.post('account/processaccount', 'application/json', processRequest)
        .then((data: { success: boolean }) => {
            console.log(data.success ? "User processed successfully" : "Error processing user");
        });
};

const canAccessClient = (accessTokenPayload: AccessTokenPayload) => {
    const clientId = accessTokenPayload.client_id.toLowerCase();
    const audience = accessTokenPayload.audience;

    return Array.isArray(audience)
        ? audience.some(aud => aud.toLowerCase() === clientId)
        : audience.toLowerCase() === clientId;
};

const handleUnauthorizedAccess = (isAuthenticated: boolean, navigate: any, logout: any) => {
    sessionStorage.setItem('signedOut', 'true');
    navigate('/Home/401');

    if (isAuthenticated) {
        setTimeout(() => {
            logout();
        }, 30000);
    }
};

const handleRelogin = (isAuthenticated: boolean, logout: any) => {
    //For force password change, we will not show banner force to log out.
    sessionStorage.setItem('signedOut', 'true');

    if (isAuthenticated) {
        //Force user to re-login
        sessionStorage.setItem('needRelogin', 'true');
        logout();
    }
};

export const CustomLoading = () => {
    const { accessTokenPayload } = useOidcAccessToken();
    const fetchWrapper = useFetchWrapper();
    const navigate = useNavigate();
    const { logout, isAuthenticated } = useOidc();

    useEffect(() => {
        if (accessTokenPayload?.sub) {
            if (accessTokenPayload.force_password_change === 'true' ||
                accessTokenPayload.has_security_question === 'false' ||
                accessTokenPayload.email_verified === 'false' )
            {
                handleRelogin(isAuthenticated, logout);
            } else if (!canAccessClient(accessTokenPayload)) {
                handleUnauthorizedAccess(isAuthenticated, navigate, logout);
            } else {
                processToken(accessTokenPayload, fetchWrapper);
            }
        }
    }, [accessTokenPayload, fetchWrapper, navigate, logout, isAuthenticated]);

    return null;
}

export default CustomLoading;
